import { AuthRepository } from "../../../data/repository/auth/AuthRepository";
import { UploadFileRepository } from "../../../data/repository/uploadFIle/UploadFileRepository";
import { Attachment } from "../../model/Attachment";
import { AccessToken, Auth } from "../../model/Auth";
import { ResponseState, State } from "../../model/ResponseState";

export interface UploadMultipleFilesUseCase {
  invoke: (filesFormData: FormData) => Promise<ResponseState<Array<string>>>;
}

export class UploadMultipleFilesUseCaseImpl implements UploadMultipleFilesUseCase {
  private uploadFileRepository: UploadFileRepository;

  constructor(uploadFileRepository: UploadFileRepository) {
    this.uploadFileRepository = uploadFileRepository;
  }

  async invoke(filesFormData: FormData): Promise<ResponseState<Array<string>>> {
    try {
      let response = await this.uploadFileRepository.uploadMultipleFiles(
        filesFormData
      );
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
